const colors: any = {
  primary: "#e16945",
  primaryShade: "#b45033",
  primaryTint: "#f8dad1",
  dark: "#4d6572",
  medium: "#7b98ad",
  light: "#f2f2f4",
  text: "#4d6572",
  textShade: "#364750",
  textTint: "#638192",
  danger: "#e34860",
  warning: "#fdb555",
  success: "#00ba6c",
  info: "#54b4d3"
};

export default colors;